module.exports = __webpack_public_path__ + "img/icon-menu-user.5ea1b172.svg";